var padResponsive = {
  "padding": "10px !important",
  "@media (min-width: 375px)": {
    "padding": "12px !important"
  },
  "@media (min-width: 768px)": {
    "padding": "18px !important"
  },
  "@media (min-width: 1024px)": {
    "padding": "20px !important"
  },
  "@media (min-width: 1280px)": {
    "padding": "20px !important"
  }
};

export { padResponsive };
